export default __webpack_public_path__ + "static/media/article 7.1769ed08.png";